module.exports = __webpack_public_path__ + "img/MG-title-01.56af500f.png";